module.exports = __webpack_public_path__ + "static/img/1.56cba66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/1.png
// module id = hxOt
// module chunks = 1